module.exports = __webpack_public_path__ + "static/media/twitter.74eca293.svg";